import { styled } from '@mui/material'
import { DatePicker as DatePickerMui } from '@mui/x-date-pickers/DatePicker'

export const DatePicker = styled(DatePickerMui)<{ error?: boolean }>(
  ({ theme, error }: any) => ({
    // Sem marginTop aqui: o gap entre label e campo já vem do `mb="4px"` do
    // label (mesmo valor que Textfield e Select da library usam). Com os 4px
    // extras o input do DatePicker descia e desalinhava de qualquer Textfield
    // ou Select na mesma linha do grid.
    borderColor: error && theme.palette.error[300],
    color: error && theme.palette.error[300],
    fontSize: '14px',
    '& .MuiOutlinedInput-root': {
      color: error && theme.palette.error[300],
      '& fieldset': {
        color: error && theme.palette.error[300],
        borderColor: error && theme.palette.error[300]
      },
      '&:hover fieldset': {
        color: error && theme.palette.error[300],
        borderColor: error && theme.palette.error[300]
      },
      '&.Mui-focused fieldset': {
        color: error && theme.palette.error[300],
        borderColor: error && theme.palette.error[300]
      }
    },
    '& .Mui-selected': {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: 'red'
      }
    }
  })
)
